import graphql from './graphql';
import { clearToken, setToken } from '../Utils/Token';
import { clearPassword, setPassword } from '../Utils/Password';

export const changePassword = async (oldPassword, newPassword) => {
  const response = await graphql('User_changePassword', 'isFirstTime transactionStatus', 'mutation', {
    oldPassword,
    newPassword,
  });

  if (response.transactionStatus) {
    clearPassword();
  }

  return response;
};

export const getLoggedUser = async () => {
  const response = await graphql(
    'User_logged',
    'fullName telephone age payrollNum isFirstTime id roleId email photo error { message code }'
  );

  if (response?.User_logged?.error) {
    const code = response?.User_logged?.error?.code;

    if (code === 'USER_NOT_FOUND' || code === 'UNAUTHORIZED') {
      localStorage.removeItem('token');
      localStorage.removeItem('password');
    }
  }

  return response;
};

export const login = async (payrollNum, password = '') => {
  setToken(null);
  const response = await graphql(
    'User_login',
    'token fullName telephone age payrollNum isFirstTime id status roleId Role { id }',
    'mutation',
    {
      payrollNum,
      password,
    }
  );

  if (!response.error) {
    setToken(response.User_login.token);
    setPassword(password);
  }

  return response;
};

export const logOut = async () => {
  let response = await graphql('User_logOut', 'transactionStatus', 'mutation');

  response = response.User_logOut;

  clearToken();

  return response;
};
